/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_Speciallist_Charmstrong2Inputs */

const id_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesona LEGO`)
};

const ms_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesona LEGO`)
};

const da_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Charme`)
};

const de_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO-Charme`)
};

const en_us2_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Charm`)
};

const es_es2_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encanto LEGO`)
};

const es_mx2_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encanto LEGO`)
};

const fil_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Charm`)
};

const fr_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charme LEGO`)
};

const it_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fascino LEGO`)
};

const hu_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO báj`)
};

const nl_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO charme`)
};

const no_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO-sjarm`)
};

const pl_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urok LEGO`)
};

const pt_br2_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amuleto LEGO`)
};

const pt_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encanto LEGO`)
};

const ro_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farmec LEGO`)
};

const fi_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO- viehätys`)
};

const sv_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO-charm`)
};

const vi_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sự quyến rũ của LEGO`)
};

const tr_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Cazibesi`)
};

const cs_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kouzlo LEGO`)
};

const bg_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO чар`)
};

const ru_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очарование LEGO`)
};

const uk_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чарівність LEGO`)
};

const ar_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سحر LEGO`)
};

const hi_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO आकर्षण`)
};

const th_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เสน่ห์ของ LEGO`)
};

const ja_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO の魅力`)
};

const zh_cn2_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`乐高魅力`)
};

const zh_hant1_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`樂高魅力`)
};

const ko_misc_posts_speciallist_charmstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Charmstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO의 매력`)
};

/**
* | output |
* | --- |
* | "LEGO Charm" |
*
* @param {Misc_Posts_Speciallist_Charmstrong2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_speciallist_charmstrong2 = /** @type {((inputs?: Misc_Posts_Speciallist_Charmstrong2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Speciallist_Charmstrong2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "ms") return ms_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "da") return da_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "de") return de_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "en-US") return en_us2_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "fil") return fil_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "fr") return fr_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "it") return it_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "hu") return hu_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "nl") return nl_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "no") return no_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "pl") return pl_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "pt") return pt_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "ro") return ro_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "fi") return fi_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "sv") return sv_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "vi") return vi_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "tr") return tr_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "cs") return cs_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "bg") return bg_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "ru") return ru_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "uk") return uk_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "ar") return ar_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "hi") return hi_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "th") return th_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "ja") return ja_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_speciallist_charmstrong2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_speciallist_charmstrong2(inputs)
	return ko_misc_posts_speciallist_charmstrong2(inputs)
});
export { misc_posts_speciallist_charmstrong2 as "misc.posts.specialList.charmStrong" }